import type {
  DeviceInfoInput,
  DriverDto,
  SessionDto,
  UpdateProfileInput,
} from "@mandoob/shared";

import {
  type MutationHookOptions,
  type QueryHookOptions,
  type RequestOptions,
  useApiMutation,
  useApiQuery,
} from "@/api/query-helpers";
import { api } from "@/lib/api-client";

const BASE = "/api/session";

export const getSession = (options?: RequestOptions, signal?: AbortSignal) =>
  api<SessionDto>({ url: BASE, method: "GET", signal }, options);

export const getGetSessionQueryKey = () => [BASE] as const;

export const useGetSession = (options?: QueryHookOptions<SessionDto>) =>
  useApiQuery(
    getGetSessionQueryKey(),
    (request, signal) => getSession(request, signal),
    options,
  );

export const updateProfile = (
  data: UpdateProfileInput,
  options?: RequestOptions,
) => api<DriverDto>({ url: `${BASE}/profile`, method: "PUT", data }, options);

export const useUpdateProfile = (
  options?: MutationHookOptions<DriverDto, UpdateProfileInput>,
) => useApiMutation((data, request) => updateProfile(data, request), options);

/** Silent device report — see lib/device-info.ts for what is gathered. */
export const reportDevice = (data: DeviceInfoInput, options?: RequestOptions) =>
  api<void>({ url: `${BASE}/device`, method: "PUT", data }, options);
